import React, { createContext, useState, useEffect, useCallback } from 'react';
import { enhancedApi } from '../api';

export const EmailSuggestionsContext = createContext({
  suggestions: [],
  count: 0,
  loading: false,
  error: null,
  refresh: () => {},
});

export const EmailSuggestionsProvider = ({ children }) => {
  const [suggestions, setSuggestions] = useState([]);
  const [count, setCount] = useState(0);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchSuggestions = useCallback(async () => {
    try {
      setLoading(true);
      setError(null);
      const response = await enhancedApi.getEmailSuggestions();
      const data = response?.data;
      const list = data?.suggestions ?? [];
      setSuggestions(Array.isArray(list) ? list : []);
      setCount(data?.count ?? list?.length ?? 0);
    } catch (err) {
      setError(err?.response?.data?.error || 'Failed to load suggestions');
      setSuggestions([]);
      setCount(0);
      console.error(err);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchSuggestions();
  }, [fetchSuggestions]);

  return (
    <EmailSuggestionsContext.Provider
      value={{ suggestions, count, loading, error, refresh: fetchSuggestions }}
    >
      {children}
    </EmailSuggestionsContext.Provider>
  );
};
